module.exports = __webpack_public_path__ + "static/img/calendar-icon.d49deeb2.svg";